export class ResetpassForm{
	constructor(
		public email:string
	){}
}
